// src/components/charts/TransactionTypeChart.jsx
import { useMemo } from "react";
import Chart from "react-apexcharts";

const TransactionTypeChart = ({ transactionTypeStats, themeColor }) => {
    const rootStyle = getComputedStyle(document.documentElement);
    const themeColorSecondary = `rgb(${rootStyle
        .getPropertyValue("--theme-color-secondary")
        .trim()})`;

    // Extract Topup & Transfer
    const { topupAmount, transferAmount } = useMemo(() => {
        let topup = 0;
        let transfer = 0;

        transactionTypeStats.forEach((t) => {
            if (t.type === "topup") topup = Number(t.total_amount || 0);
            if (t.type === "transfer") transfer = Number(t.total_amount || 0);
        });

        return { topupAmount: topup, transferAmount: transfer };
    }, [transactionTypeStats]);

    const total = topupAmount + transferAmount;
    const percentage = total === 0 ? 0 : Math.round((topupAmount / total) * 100);

    const options = {
        chart: {
            type: "radialBar",
            sparkline: { enabled: true },
        },
        colors: [themeColor], // 🔥 base color
        fill: {
            type: "gradient",
            gradient: {
                type: "horizontal",
                gradientToColors: [themeColorSecondary],
                stops: [0, 100],
            },
        },
        plotOptions: {
            radialBar: {
                startAngle: -90,
                endAngle: 90,
                hollow: {
                    size: "55%",
                },
                track: {
                    background: "#E6E8EC",
                    strokeWidth: "110%",
                },
                dataLabels: {
                    name: {
                        show: false,
                    },
                    value: {
                        offsetY: -2,
                        fontSize: "40px",
                        fontWeight: 600,
                        formatter: (val) => `${val}%`,
                    },
                },
            },
        },
        stroke: {
            lineCap: "butt", // 🔥 less circular ends
        },
        labels: ["Percentage"],
    };

    return (
        <div className="text-center">
            <Chart options={options} series={[percentage]} type="radialBar" />

            {/* Bottom legend */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                    fontSize: "13px",
                    color: "#6B7280",
                    marginTop: "20px",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span
                        style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            background: `linear-gradient(90deg, ${themeColor}, ${themeColorSecondary})`,
                        }}
                    />
                    Topup
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span
                        style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: "#E6E8EC",
                        }}
                    />
                    Transfer
                </div>
            </div>
        </div>
    );
};

export default TransactionTypeChart;
